import { render, staticRenderFns } from "./ViewEdit-Build.vue?vue&type=template&id=3c78981d"
import script from "./ViewEdit-Build.vue?vue&type=script&lang=js"
export * from "./ViewEdit-Build.vue?vue&type=script&lang=js"
import style0 from "./ViewEdit-Build.vue?vue&type=style&index=0&id=3c78981d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports